import { useState } from 'react';
import type { MessageAttachment } from '@teo/widget-shared';
import { useWidget } from '../context/WidgetContext.js';
import { useRichMedia } from './RichMediaContext.js';

type ImageAttachmentProps = {
  attachment: MessageAttachment;
  onMediaLoad?: () => void;
};

export function ImageAttachment({ attachment, onMediaLoad }: ImageAttachmentProps) {
  const { t } = useWidget();
  const { openLightbox } = useRichMedia();
  const [failed, setFailed] = useState(false);
  const [loaded, setLoaded] = useState(false);

  if (failed) {
    return (
      <a
        className="teo-rich-media__fallback"
        href={attachment.url}
        target="_blank"
        rel="noopener noreferrer"
      >
        <span className="teo-rich-media__fallback-label">{t.mediaLoadError}</span>
        <span className="teo-rich-media__fallback-action">{t.mediaOpenPreview}</span>
      </a>
    );
  }

  return (
    <button
      type="button"
      className={[
        'teo-rich-media__thumb-btn',
        'teo-rich-media__thumb-btn--image',
        loaded ? '' : 'teo-media-skeleton',
      ]
        .filter(Boolean)
        .join(' ')}
      onClick={() =>
        openLightbox({
          kind: 'image',
          url: attachment.url,
          title: attachment.fileName,
        })
      }
      aria-label={attachment.fileName ?? 'Image'}
    >
      <img
        className="teo-rich-media__image"
        src={attachment.url}
        alt={attachment.fileName ?? ''}
        loading="lazy"
        onLoad={() => {
          setLoaded(true);
          onMediaLoad?.();
        }}
        onError={() => setFailed(true)}
      />
    </button>
  );
}
